import "components/pages/insGridPage.scss";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetDatapointsDataWithFilters } from "../hooks/useGetDatapointsDataWithFilters";
import { PortfolioCreationChoice } from "../types";
import { DatapointIdStandardEnum } from "api/ux/src";
import { addCustomFieldsAsCols, addCustomFieldsAsDatapoints } from "components/modal/portfolio-creation-edit/helper";
import { InsGridWidget } from "components/widgets";
import { InsGridAggs } from "components/widgets/grid/grid-agg-funcs";
import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import { getDefaultMappings, insDatapointGridWidgetAdapterData } from "components/widgets/grid/insDatapointGridWidgetAdapter";
import { getMeasuresAndDimensionsWithCurrency } from "hooks/use-funds-page";
import { useGetCustomDatapointDimensionsByPortfolioCreationChoice } from "hooks/widget-data/use-datapoints";
import { useRefreshOnUserSettingsChange } from "hooks/widget-data/user-settings/user-settings";
import { setSelectedRowsState } from "store/grids";
import { AddInvestorAccountsOrFundsMode } from "store/modal/portfolio-creation-types";
const getMeasuresAndDimensionsForFunds = (customFields) => {
    const datapoints = [
        { datapoint: { standard: DatapointIdStandardEnum.FundFundId }, name: "Id" },
        { datapoint: { standard: DatapointIdStandardEnum.FundFundName }, name: "Name" },
        { datapoint: { standard: DatapointIdStandardEnum.FundCurrency }, name: "Currency" },
        { datapoint: { standard: DatapointIdStandardEnum.FundReportedCommitment }, name: "Commitment" },
        { datapoint: { standard: DatapointIdStandardEnum.FundVintageYear }, name: "Vintage" },
        { datapoint: { standard: DatapointIdStandardEnum.FundStrategy }, name: "Strategy" }
    ];
    addCustomFieldsAsDatapoints(customFields, datapoints);
    return getMeasuresAndDimensionsWithCurrency(["Id"], datapoints);
};
const useCreateColInsOnlyFunds = (customFields) => {
    const cols = [
        { field: "Id", hide: true, lockVisible: true },
        { field: "Name", headerName: "Fund", sort: "asc", type: CustomColumnType.AUX_TEXT_COLUMN },
        { field: "Currency", headerName: "Fund Currency", type: CustomColumnType.AUX_TEXT_COLUMN, width: 120 },
        { aggFunc: InsGridAggs.totalData, field: "Commitment", type: CustomColumnType.InsMoneyColumn, width: 120 },
        { field: "Vintage", headerName: "Vintage", type: CustomColumnType.AUX_TEXT_COLUMN, width: 80 },
        { field: "Strategy", headerName: "Strategy", type: CustomColumnType.AUX_TEXT_COLUMN }
    ];
    addCustomFieldsAsCols(customFields, cols);
    return cols;
};
export const portfolioCreationFundsRulesBasedGridId = "portfolio-creation-funds-rules-based-grid";
export const InsPortfolioCreationFundsRulesBasedGrid = () => {
    const dispatch = useDispatch();
    const listOfCustomFields = useGetCustomDatapointDimensionsByPortfolioCreationChoice(PortfolioCreationChoice.CreatePortfolioRuleBasedFunds);
    const { measures, dimensions } = getMeasuresAndDimensionsForFunds(listOfCustomFields);
    const [data, querystate, refresh] = useGetDatapointsDataWithFilters(dimensions, measures, portfolioCreationFundsRulesBasedGridId, true, AddInvestorAccountsOrFundsMode.Default);
    useRefreshOnUserSettingsChange();
    const cols = useCreateColInsOnlyFunds(listOfCustomFields);
    const { rows, totals } = insDatapointGridWidgetAdapterData(data, cols);
    const defaultLinksMapping = getDefaultMappings([{ dimensions, id: "", measures }], cols);
    const portfolioCurrency = useSelector((state) => state.portfolioCreation.information.currency);
    const currencies = [...new Set([portfolioCurrency, ...rows?.map((r) => r.Currency || "") || []])].filter((c) => c);
    return React.createElement(InsGridWidget, { rowSelectedHandler: ((e) => {
            dispatch(setSelectedRowsState({ id: portfolioCreationFundsRulesBasedGridId,
                selectedRows: e.api.getSelectedRows()
                    .map((row) => `${row.Id}`) }));
        }), selectionMode: "multiple", widgetId: portfolioCreationFundsRulesBasedGridId, stateId: portfolioCreationFundsRulesBasedGridId, columnDefs: cols, rowData: rows, refreshAction: refresh, totalData: totals, currencyData: currencies, queryState: querystate, suppressRowClickSelection: true, context: { linksMapping: defaultLinksMapping }, hideFilters: true });
};
